// extracted by mini-css-extract-plugin
export var measureBox = "_6h-0";